<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span>To My Aunt for her Ninety-first Birthday</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-dedication.vue?d17e08ba